import { default as MuiRating, RatingProps } from '@mui/material/Rating'
import { default as React } from 'react'

const Rating: React.FC<React.PropsWithChildren<RatingProps>> = (props) => {
  return <MuiRating {...props} />
}

export default Rating
